var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{is_fixed: _vm.isFixed},attrs:{"id":"app"}},[_c('router-view',{attrs:{"to":"/"}}),(this.isLoading)?[_c('loading')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }